import { render, staticRenderFns } from "./tempPenetapanGPT.vue?vue&type=template&id=35c82ad0&"
import script from "./tempPenetapanGPT.vue?vue&type=script&lang=js&"
export * from "./tempPenetapanGPT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports